var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticStyle: { position: "relative" } },
    [
      _vm.isLoading
        ? _c(
            "v-layout",
            {
              staticStyle: {
                position: "absolute",
                top: "0",
                left: "0",
                right: "0",
                bottom: "0",
                "z-index": "1000",
                background: "rgba(255, 255, 255, .95)"
              },
              attrs: { "align-center": "", "justify-center": "" }
            },
            [
              _c("div", { staticClass: "primary--text" }, [
                _c("div", { staticClass: "lds-roller" }, [
                  _c("div"),
                  _c("div"),
                  _c("div"),
                  _c("div"),
                  _c("div"),
                  _c("div"),
                  _c("div"),
                  _c("div")
                ]),
                _vm._v(" "),
                _c("div", [_vm._v("Patientez SVP ...")])
              ])
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      _c(
        "v-layout",
        { attrs: { wrap: "", "px-0": "" } },
        [
          _c(
            "v-flex",
            {
              staticClass: "form-section",
              attrs: { xs12: "", md4: "", "pl-4": "", "pr-3": "", "pl-0": "" }
            },
            [
              _c(
                "v-flex",
                { attrs: { "mb-3": "", xs12: "", md12: "" } },
                [
                  _c("v-layout", { staticClass: "title--text-custom" }, [
                    _c("div", { staticClass: "primary--text" }, [_vm._v("1")]),
                    _vm._v(" "),
                    _c("div", { staticClass: "secondary--text" }, [_vm._v(".")])
                  ]),
                  _vm._v(" "),
                  _c("h1", { staticClass: "primary--text " }, [
                    _vm._v(
                      _vm._s(
                        _vm.type && _vm.$route.meta["media_type_level2_allowed"]
                          ? _vm.$t(_vm.lblSetting.documentSectionTitle.firstBis)
                          : _vm.$t(_vm.lblSetting.documentSectionTitle.first)
                      )
                    )
                  ])
                ],
                1
              ),
              _vm._v(" "),
              _c("v-select", {
                staticClass: "ml-1",
                attrs: {
                  items: _vm.coTypes1,
                  "item-value": "id",
                  "item-text": "name",
                  required: true,
                  rules: _vm.dtRules.typesRules,
                  solo: ""
                },
                on: { change: _vm.handleGetTypesLevel2 },
                model: {
                  value: _vm.type,
                  callback: function($$v) {
                    _vm.type = $$v
                  },
                  expression: "type"
                }
              }),
              _vm._v(" "),
              _vm.coTypes2.length &&
              _vm.type &&
              _vm.$route.meta["media_type_level2_allowed"]
                ? _c("v-select", {
                    staticClass: "ml-1",
                    attrs: {
                      items: _vm.coTypes2,
                      "item-value": "id",
                      "item-text": "name",
                      solo: ""
                    },
                    on: { change: _vm.handleGetAttributesLevel2 },
                    model: {
                      value: _vm.typeLvl2,
                      callback: function($$v) {
                        _vm.typeLvl2 = $$v
                      },
                      expression: "typeLvl2"
                    }
                  })
                : _vm._e()
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "v-flex",
            {
              staticClass: "form-section",
              attrs: { xs12: "", md4: "", "pl-4": "", "pr-3": "", "pl-0": "" }
            },
            [
              _c(
                "v-flex",
                { attrs: { "mb-3": "", xs12: "", md12: "" } },
                [
                  _c("v-layout", { staticClass: "title--text-custom" }, [
                    _c("div", { staticClass: "primary--text" }, [_vm._v("2")]),
                    _vm._v(" "),
                    _c("div", { staticClass: "secondary--text" }, [_vm._v(".")])
                  ]),
                  _vm._v(" "),
                  _c("h1", { staticClass: "primary--text" }, [
                    _vm._v(
                      _vm._s(_vm.$t(_vm.lblSetting.documentSectionTitle.second))
                    )
                  ])
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "base-control-label-vertical",
                [
                  _c("base-attachment-button", {
                    attrs: {
                      editMode: _vm.isUpdateAction,
                      multiple: "",
                      attributes: _vm.coAttributes,
                      accept:
                        "video/*,image/*,.pdf,.doc,.docx,.xml.xlsx,.xls,.ppt, .pptx,.txt,\n                                application/msword,\n                                application/vnd.openxmlformats-officedocument.wordprocessingml.document"
                    },
                    model: {
                      value: _vm.attachments,
                      callback: function($$v) {
                        _vm.attachments = $$v
                      },
                      expression: "attachments"
                    }
                  })
                ],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "v-flex",
            {
              staticClass: "form-section",
              attrs: { xs12: "", md4: "", "pl-4": "", "pr-3": "", "pl-0": "" }
            },
            [
              _c(
                "v-flex",
                { attrs: { "mb-3": "", xs12: "", md12: "" } },
                [
                  _c("v-layout", { staticClass: "title--text-custom" }, [
                    _c("div", { staticClass: "primary--text" }, [_vm._v("3")]),
                    _vm._v(" "),
                    _c("div", { staticClass: "secondary--text" }, [_vm._v(".")])
                  ]),
                  _vm._v(" "),
                  _c("h1", { staticClass: "primary--text" }, [
                    _vm._v(
                      _vm._s(_vm.$t(_vm.lblSetting.documentSectionTitle.third))
                    )
                  ])
                ],
                1
              ),
              _vm._v(" "),
              _vm.isDocumentRoute
                ? _c("v-switch", {
                    staticClass: "pl-3 mt-0",
                    attrs: {
                      color: "primary",
                      label:
                        "Tous les " +
                        _vm.$t(_vm.lblSetting.document_form.blocks)
                    },
                    model: {
                      value: _vm.shareWithAllBlocks,
                      callback: function($$v) {
                        _vm.shareWithAllBlocks = $$v
                      },
                      expression: "shareWithAllBlocks"
                    }
                  })
                : _vm._e(),
              _vm._v(" "),
              _vm.shareWithAllBlocks
                ? [
                    _vm.shareWithAllBlocks
                      ? _c(
                          "base-control-label-vertical",
                          { attrs: { label: "Rôles" } },
                          [
                            _c("base-multi-select", {
                              attrs: {
                                options: _vm.dtRoles,
                                "return-object": false,
                                loading: _vm.rolesLoading,
                                disabled: _vm.rolesLoading,
                                multiple: true,
                                placeholder: "Séléctionner des rôles ...",
                                "item-text": "text",
                                "item-value": "id"
                              },
                              model: {
                                value: _vm.roles,
                                callback: function($$v) {
                                  _vm.roles = $$v
                                },
                                expression: "roles"
                              }
                            })
                          ],
                          1
                        )
                      : _vm._e()
                  ]
                : [
                    !_vm.isServiceBook
                      ? [
                          !_vm.isTicketChat
                            ? _c(
                                "base-control-label-vertical",
                                {
                                  attrs: {
                                    label: _vm.isServiceBookUser
                                      ? "Adresse"
                                      : _vm.lblSetting.document_form.blocks
                                  }
                                },
                                [
                                  _c("base-autocomplete", {
                                    attrs: {
                                      items: _vm.coBlocks,
                                      multiple: true,
                                      required: !(
                                        _vm.apartments &&
                                        _vm.apartments.length > 0
                                      ),
                                      rules:
                                        _vm.apartments &&
                                        _vm.apartments.length > 0
                                          ? []
                                          : _vm.dtRules.blockRules,
                                      "return-object": false,
                                      clearable: true,
                                      disabled:
                                        _vm.$route.name === "block_documents" ||
                                        _vm.equipment !== null,
                                      "on-fetch-remote":
                                        _vm.handleGetBlockAutocomplete,
                                      icon: "icon icon-blocks",
                                      "item-value": "id",
                                      "item-text": "name",
                                      "is-solo": ""
                                    },
                                    on: { change: _vm.handleBlockChange },
                                    model: {
                                      value: _vm.fkBlocks,
                                      callback: function($$v) {
                                        _vm.fkBlocks = $$v
                                      },
                                      expression: "fkBlocks"
                                    }
                                  })
                                ],
                                1
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          !_vm.isTicketChat &&
                          (_vm.fkBlocks && _vm.fkBlocks.length > 0) &&
                          _vm.coApartments.length
                            ? _c(
                                "base-control-label-vertical",
                                {
                                  attrs: {
                                    label: _vm.isServiceBookUser
                                      ? "Lot"
                                      : _vm.lblSetting.document_form.apartments
                                  }
                                },
                                [
                                  _c("base-autocomplete", {
                                    key: 2,
                                    attrs: {
                                      icon: "",
                                      required: !(
                                        _vm.fkBlocks && _vm.fkBlocks.length > 0
                                      ),
                                      rules:
                                        _vm.fkBlocks && _vm.fkBlocks.length > 0
                                          ? []
                                          : _vm.dtRules.apartmentRules,
                                      "item-value": "id",
                                      "item-text": "apartment_number",
                                      items: _vm.coApartments,
                                      disabled: _vm.equipment !== null,
                                      "on-fetch-remote":
                                        _vm.handleGetApartmentAutocomplete,
                                      "return-object": false,
                                      multiple: true,
                                      "is-solo": ""
                                    },
                                    on: { change: _vm.handleApartmentChange },
                                    model: {
                                      value: _vm.apartments,
                                      callback: function($$v) {
                                        _vm.apartments = $$v
                                      },
                                      expression: "apartments"
                                    }
                                  })
                                ],
                                1
                              )
                            : _vm._e()
                        ]
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.showEquipmentSelector()
                      ? _c(
                          "base-control-label-vertical",
                          { attrs: { label: _vm.lblSetting.blockEquipments } },
                          [
                            _c("base-multi-select", {
                              attrs: {
                                rules: _vm.equipmentRules,
                                options: _vm.coEquipments,
                                itemText: "name",
                                itemSubtext: "reference",
                                "return-object": false,
                                multiple: true,
                                fetch: _vm.handleGetEquipments,
                                icon: "handyman",
                                disabled: _vm.equipment !== null
                              },
                              on: { change: _vm.handleChangeEquipment },
                              model: {
                                value: _vm.fkEquipment,
                                callback: function($$v) {
                                  _vm.fkEquipment = $$v
                                },
                                expression: "fkEquipment"
                              }
                            })
                          ],
                          1
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.fkBlocks && _vm.fkBlocks.length
                      ? [
                          _vm.$route.meta["share_document_by_owner"]
                            ? _c("v-switch", {
                                staticClass: "share-file__switcher ml-1",
                                attrs: {
                                  color: "primary",
                                  label: _vm.$t(
                                    _vm.lblSetting.document_form
                                      .shareWithBlockOwners
                                  )
                                },
                                model: {
                                  value: _vm.shareWithBlockOwners,
                                  callback: function($$v) {
                                    _vm.shareWithBlockOwners = $$v
                                  },
                                  expression: "shareWithBlockOwners"
                                }
                              })
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.$route.meta["share_document_by_tenant"]
                            ? _c("v-switch", {
                                staticClass: "share-file__switcher ml-1",
                                attrs: {
                                  color: "primary",
                                  label: _vm.$t(
                                    _vm.lblSetting.document_form
                                      .shareWithBlockTenants
                                  )
                                },
                                model: {
                                  value: _vm.shareWithBlockTenants,
                                  callback: function($$v) {
                                    _vm.shareWithBlockTenants = $$v
                                  },
                                  expression: "shareWithBlockTenants"
                                }
                              })
                            : _vm._e()
                        ]
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.apartments && _vm.apartments.length
                      ? [
                          _vm.$route.meta["share_document_by_owner"]
                            ? _c("v-switch", {
                                staticClass: "share-file__switcher ml-1",
                                attrs: {
                                  color: "primary",
                                  label: _vm.$t(
                                    _vm.lblSetting.document_form
                                      .shareWithApartmentOwners
                                  )
                                },
                                model: {
                                  value: _vm.shareWithApartmentOwners,
                                  callback: function($$v) {
                                    _vm.shareWithApartmentOwners = $$v
                                  },
                                  expression: "shareWithApartmentOwners"
                                }
                              })
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.$route.meta["share_document_by_tenant"]
                            ? _c("v-switch", {
                                staticClass: "share-file__switcher ml-1",
                                attrs: {
                                  color: "primary",
                                  label: _vm.$t(
                                    _vm.lblSetting.document_form
                                      .shareWithApartmentTenants
                                  )
                                },
                                model: {
                                  value: _vm.shareWithApartmentTenants,
                                  callback: function($$v) {
                                    _vm.shareWithApartmentTenants = $$v
                                  },
                                  expression: "shareWithApartmentTenants"
                                }
                              })
                            : _vm._e()
                        ]
                      : _vm._e()
                  ],
              _vm._v(" "),
              _vm.$route.meta["share_document_in_app"]
                ? _c(
                    "base-control-label-vertical",
                    {
                      attrs: {
                        label: _vm.lblSetting.document_form.shareWithEntities
                      }
                    },
                    [
                      _c("base-autocomplete", {
                        attrs: {
                          items: _vm.coEntities,
                          multiple: true,
                          "return-object": false,
                          "on-fetch-remote": _vm.handleGetEntityAutocomplete,
                          "item-value": "value",
                          "is-solo": ""
                        },
                        model: {
                          value: _vm.entities,
                          callback: function($$v) {
                            _vm.entities = $$v
                          },
                          expression: "entities"
                        }
                      })
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _c("base-control-label-vertical", {
                attrs: { label: _vm.lblSetting.document_form.shareDescription }
              })
            ],
            2
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-069f480f", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-069f480f","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./src/containers/documents/components/document-modal-vertical/template.html
// module id = null
// module chunks = 